import React from "react";
import { Form, Card } from "react-bootstrap";

/**
 * Renders a single diagnostic question with radio options.
 * Does NOT expose is_correct — options are shown as plain text.
 */
function DiagnosticQuestion({
  question,
  questionNumber,
  total,
  selectedAnswer,
  onSelect,
}) {
  const { id, text, options } = question;

  return (
    <Card className="mb-3">
      <Card.Body>
        <p className="text-muted small mb-1">
          Pregunta {questionNumber} de {total}
        </p>
        <p className="fw-semibold mb-3">{text}</p>
        <div className="d-flex flex-column gap-2">
          {options.map((opt) => (
            <Form.Check
              key={opt.id}
              type="radio"
              id={`q${id}-opt${opt.id}`}
              name={`question-${id}`}
              label={opt.text}
              checked={selectedAnswer === opt.id}
              onChange={() => onSelect(opt.id)}
              style={{ minHeight: 44, display: "flex", alignItems: "center" }}
            />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}

export { DiagnosticQuestion };
